<template>
	<div class="account-statement">
		<DrawerAccountStatement ref="drawer_account_statement" />
		<ModalAddCollection ref="modal_add_collection" />
		<b-card no-body>
			<b-card-header class="p-3 d-flex justify-content-between align-items-center">
				<h3 class="mb-0">Account Statement</h3>
				<div class="d-flex align-items-center text-primary cursor-pointer"
					@click="$refs.drawer_account_statement.show()">
					<p class="text-primary">View Details</p>
					<svg xmlns="http://www.w3.org/2000/svg" class="ml-1" width="8" height="20" viewBox="0 0 320 512">
						<path fill="currentColor"
							d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
					</svg>
				</div>
			</b-card-header>
			<div class="m-3">
				<span class="text-muted mb-2">Updated {{ _gHlp.formatMomentDate(latest_update_at,'D MMM, YYYY') }}</span>
				<div class="d-flex align-items-center mb-2" v-for="(item,index) in lastStatements" :key="'clect-'+index">
					<svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="20" viewBox="0 0 448 512">
						<path fill="#0BC196"
							d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z" />
					</svg>
					<p>{{ item.description }}</p>
				</div>
				<!-- <div class="d-flex align-items-center mb-2">
					<svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="20" viewBox="0 0 448 512">
						<path fill="#0BC196"
							d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z" />
					</svg>
					<p>Rebate Advanced</p>
				</div>
				<div class="d-flex align-items-center mb-3">
					<svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="16" viewBox="0 0 512 512">
						<path fill="#DF3030"
							d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z" />
					</svg>
					<p>Late Charges</p>
				</div> -->
				<div class="d-flex align-items-center text-primary cursor-pointer justify-content-center" @click="$refs.modal_add_collection.show()">
					<svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="20" viewBox="0 0 448 512">
						<path fill="currentColor"
							d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
					</svg>
					<p class="text-primary">Add Collection</p>
				</div>
			</div>
		</b-card>
	</div>
</template>
<script>
import { Card, Button } from 'element-ui'
import DrawerAccountStatement from '@/views/CreditLoanCase/Drawers/DrawerAccountStatement'
import ModalAddCollection from '@/views/CreditLoanCase/Modals/ModalAddCollection';

export default {
	props:['lastStatements'],
	components: {
		DrawerAccountStatement,
		ModalAddCollection,
		[Card.name]: Card,
		[Button.name]: Button,
	},
	data() {
		return {
		}
	},
	computed: {
		latest_update_at(){
			if(_gHlp.isEmpty(this.lastStatements)) return null
			return this.lastStatements[this.lastStatements.length - 1].updated_at
		}
	}
}
</script>